/** Current status of project's checklist */
export enum ChecklistStatusEnum {
	/** Checklist created */
	NEW = 'NEW',
	/** Checklist succeed */
	SUCCESS = 'SUCCESS',
	/** Checklist failed */
	FAILED = 'FAILED',
	/** System checklist */
	SYSTEM = 'SYSTEM'
}
